import { useEffect, useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import api from '@/services/api';

/**
 * Resolves the correct "Dashboard" destination based on auth state + role.
 *
 *   logged out      -> /login
 *   admin           -> /admin
 *   DJ              -> /dj-dashboard
 *   everyone else   -> /profile
 *
 * The admin role is NOT part of the auth payload, so we resolve it from
 * /users/me (the same source the Navbar uses). Until that resolves we fall
 * back to the non-admin branch, then update reactively — safe, never a dead
 * route. If the role lookup fails we default to /profile.
 */
export function useDashboardTarget() {
  const { user, isAuthenticated } = useAuth();
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    let active = true;
    if (isAuthenticated && api.isAuthenticated()) {
      api.get('/users/me')
        .then((me) => { if (active) setIsAdmin(me?.role === 'admin'); })
        .catch(() => { if (active) setIsAdmin(false); });
    } else {
      setIsAdmin(false);
    }
    return () => { active = false; };
  }, [isAuthenticated]);

  if (!isAuthenticated) return '/login';
  if (isAdmin) return '/admin';
  if (user?.user_type === 'dj') return '/dj-dashboard';
  return '/profile';
}

export default useDashboardTarget;
